export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_gptrading.png",
      alt: "GPTrading",
    },
    title: "Invista com a GPtrading",
    text: [
      "A GPtrading desenvolve soluções automatizadas para quem leva o mercado a sério. \n\nNossos sistemas foram criados para ajudar você a operar com mais estratégia, controle de risco e diversificação. Se o seu objetivo é consistência e liberdade, está no lugar certo. \n\nAqui, o trader vem em primeiro lugar. Esqueça promessas vazias, aqui o que importa é resultado. ",
    ],
    testimonial: {
      text: "Automatizar é só o começo. Na GPtrading, você opera com estratégia, controle e visão de mercado real.",
      author: {
        name: "Victor Garcia",
        // "picture": "https://i.pravatar.cc/150?img=70"
      },
    },
  },
  stats: {
    title: "Alguns números da GPTrading",
    subtitle: "Tecnologia aplicada, estratégias validadas e execução em escala real.",
    data: [
      {
        value: "+480%",
        description: "Nos últimos 6 meses",
      },
      {
        value: "+700",
        description: "clientes satisfeitos",
      },
      {
        value: "+ 1 milhão",
        description: "de ordens executadas no ano ",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da Gptrading?",
    subtitle: "Veja quais as principais vantagens dos robôs da GPTrading.",
    data: [
      {
        title: "7 dias pra testar",
        description: "Avalie a estratégia antes de investir.",
      },
      {
        title: "Automação completa",
        description: "Sem ajustes manuais. Tudo pronto para rodar.",
      },
      {
        title: "Suporte de verdade",
        description: "Atendimento direto com especialistas.",
      },
      {
        title: "Alta velocidade",
        description: "Decisões em milissegundos, baseadas em fluxo real.",
      },
      {
        title: "Economia de tempo ",
        description: "Operações automáticas enquanto você vive.",
      },
      {
        title: "Sem interferência emocional",
        description: "Execução 100% racional, sem impulsos.",
      },
    ],
  },
  cta: {
    title: "Pronto para começar?",
    subtitle: "Ative agora mesmo sua automação com a GPtrading.",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A GPtrading",
    col1: [
      " GPtrading surgiu a partir da necessidade real de unir experiência prática no mercado financeiro com soluções automatizadas de alta performance. Desenvolvemos sistemas que interpretam o fluxo com precisão, executam com disciplina e priorizam a gestão de risco. \n\nNosso compromisso é entregar tecnologia eficiente, baseada em estratégias validadas, desenvolvidas por profissionais que conhecem a dinâmica do mercado além da teoria.",
    ],
    col2: [
      "Mais do que criar robôs, construímos ferramentas que ampliam a visão do trader e o ajudam a operar com mais clareza, controle e confiança. \n\nNa GPtrading, automação não é promessa — é processo, estrutura e resultado. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da Gptrading",
  },
  strategies: {
    title: "ESTRATÉGIAS GPTRADING",
    heading: "Performance real com inteligência automatizada.",
    subtitle:
      "Soluções desenvolvidas por traders experientes e otimizadas por algoritmos. \nEscolha sua estratégia, conecte e acompanhe. Sem complicação.",
  },
  testimonials: [
    {
      text: "A GPtrading mudou a forma como eu opero. Os robôs são precisos, o suporte é ágil e as estratégias entregam o que prometem.",
      author: "Henrique Duarte",
      job: "Engenheiro de Produção",
      // "image_url": "https://avatars.githubusercontent.com/u/97165289"
    },
    {
      text: "Finalmente encontrei uma solução automatizada que funciona de verdade. Simples, eficiente e com atendimento que entende o mercado.",
      author: "Marina Costa",
      job: "Analista Financeira",
      // "image_url": "https://avatars.githubusercontent.com/u/97165289"
    },
  ],
};
